// Recently Visited — lightweight localStorage tracker for the Safety module.
// Each entry: { type, id, label, sublabel, path, ts, pinned }
// Deduped by `${type}:${id}`; pinned items always appear first and never get evicted.
// Unpinned cap: MAX_UNPINNED. Pinned cap: MAX_PINNED.

const KEY = "safety_recents_v1";
const MAX_UNPINNED = 10;
const MAX_PINNED = 5;

function sortRecents(list) {
  return [...list].sort((a, b) => {
    const ap = a.pinned ? 1 : 0;
    const bp = b.pinned ? 1 : 0;
    if (ap !== bp) return bp - ap;
    return (b.ts || 0) - (a.ts || 0);
  });
}

export function getRecents() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? sortRecents(list) : [];
  } catch {
    return [];
  }
}

function persist(list) {
  // Enforce caps separately for pinned and unpinned
  const pinned = list.filter((r) => r.pinned).slice(0, MAX_PINNED);
  const unpinned = list.filter((r) => !r.pinned).slice(0, MAX_UNPINNED);
  const next = sortRecents([...pinned, ...unpinned]);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent("safety:recents-changed"));
  } catch { /* quota or disabled */ }
  return next;
}

export function pushRecent(entry) {
  if (!entry || !entry.id || !entry.path) return;
  const item = {
    type: entry.type || "item",
    id: String(entry.id),
    label: entry.label || String(entry.id),
    sublabel: entry.sublabel || "",
    path: entry.path,
    ts: Date.now(),
    pinned: false,
  };
  const key = `${item.type}:${item.id}`;
  const current = getRecents();
  const existing = current.find((r) => `${r.type}:${r.id}` === key);
  if (existing) {
    item.pinned = !!existing.pinned;
  }
  const without = current.filter((r) => `${r.type}:${r.id}` !== key);
  persist([item, ...without]);
}

export function togglePin(typeId) {
  const list = getRecents().map((r) =>
    `${r.type}:${r.id}` === typeId ? { ...r, pinned: !r.pinned } : r
  );
  persist(list);
}

export function removeRecent(typeId) {
  const list = getRecents().filter((r) => `${r.type}:${r.id}` !== typeId);
  persist(list);
}

export function clearRecents() {
  // Preserve pinned; clear only unpinned
  const list = getRecents().filter((r) => r.pinned);
  persist(list);
}
